export default __webpack_public_path__ + "static/media/about-carousel-1-frame.8529d85c.jpg";